import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-53d307cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "milestone-plan-stage-status__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "milestone-plan-stage-status__arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MilestoneStageStatusItem = _resolveComponent("MilestoneStageStatusItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'milestone-plan-stage-status--left-active': _ctx.selectedStatus === 1,
      'milestone-plan-stage-status--right-active': _ctx.selectedStatus === 2,
    }, "milestone-plan-stage-status"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageStatus, (status, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "milestone-plan-stage-status__item"
        }, [
          _createVNode(_component_MilestoneStageStatusItem, {
            icon: status.icon,
            "is-clickable": false,
            title: status.title
          }, null, 8, ["icon", "title"]),
          _hoisted_2
        ]))
      }), 128))
    ])
  ], 2))
}